import { render, staticRenderFns } from "./resend-zapier-data.vue?vue&type=template&id=83669bc6&scoped=true"
import script from "./resend-zapier-data.vue?vue&type=script&lang=js"
export * from "./resend-zapier-data.vue?vue&type=script&lang=js"
import style0 from "./resend-zapier-data.vue?vue&type=style&index=0&id=83669bc6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83669bc6",
  null
  
)

export default component.exports